import React from "react";
import Asterisk from "../../../../components/common/Asterisk";
import {
  Dropdown,
  Form,
  Grid,
  GridColumn,
  Input,
  Modal,
} from "semantic-ui-react";
import { format } from "date-fns";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import calendar_icon from "../../../../../Assets/Icons/calender-icon.svg";
import DatePicker from "react-multi-date-picker";

import { useSelector } from "react-redux";
import { selectTranslations } from "../../../../config/i18n/slice";
import { CloseIcon } from "../../../../../Assets/Icons/svg";
const CostModal = ({
  handleAssign,
  options,
  fetchPeopleOptions,
  onValuesChange,
  addLaborModal,
  validation,
  setValidation,
  setaddLaborModal,
  setCostData,
  setIsEdit,
  costData,
  isEdit,
}) => {
  const t = useSelector(selectTranslations);
  const selectedLanguage = useSelector((state) => {
    if (state?.i18n?.lang) {
      return state.i18n.lang;
    } else {
      return "en";
    }
  });

  const organisationCurrency = useSelector((state) => {
    if (state?.auth?.user?.organisation) {
      return state.auth.user.organisation.currency;
    } else {
      return "JOD";
    }
  });
  const organisationTimezone = useSelector((state) => {
    if (state?.auth?.user?.organisation) {
      return state.auth.user.organisation.timezone;
    } else {
      return null;
    }
  });

  const getLocalDateTime = (offset) => {
    const now = new Date(); // Get the current time in local timezone
    const utcMilliseconds = now.getTime() + now.getTimezoneOffset() * 60000; // Convert local time to UTC
    const localMilliseconds = utcMilliseconds + offset * 3600000; // Add timezone offset in milliseconds

    const localDate = new Date(localMilliseconds);

    return format(localDate, "yyyy-MM-dd hh:mm a");
  };
  return (
    <Modal
      className="assets-modal"
      size="small"
      open={addLaborModal}
      onClose={() => {
        setaddLaborModal(false);
        setValidation({
          people: {
            error: false,
            pattern: (code) => code != "",
            skipped: false,
            message: t.common.required_field,
          },
          cost: {
            error: false,
            pattern: (code) => code != "",
            skipped: false,
            message: t.common.required_field,
          },
        });
        setCostData({
          people: "",
          startDate: getLocalDateTime(organisationTimezone?.split("+")[1]),
          cost: "",
          description: "",
          category: "Other Cost",
        });
        setIsEdit(false);
      }}
    >
      <div className="header-container">
        <span className="assets-header">
          {isEdit ? t.workOrders.cost.edit_cost : t.workOrders.cost.add_cost}
        </span>
        <div>
          <span
            className="c-pointer text-right"
            onClick={() => {
              setaddLaborModal(false);
              setIsEdit(false);
              setValidation({
                people: {
                  error: false,
                  pattern: (code) => code != "",
                  skipped: false,
                  message: t.common.required_field,
                },
                cost: {
                  error: false,
                  pattern: (code) => code != "",
                  skipped: false,
                  message: t.common.required_field,
                },
              });
              setCostData({
                people: "",
                startDate: getLocalDateTime(
                  organisationTimezone?.split("+")[1]
                ),
                cost: "",
                description: "",
                category: "Other Cost",
              });
            }}
          >
            <CloseIcon />
          </span>
        </div>
      </div>

      <Modal.Content className="pb-0">
        <div className="assignee-data">
          <Grid className="mb-0" columns={2}>
            <GridColumn className="pb-0">
              <Form.Field>
                <label className="label-item">
                  {t.workOrders.cost.date_time}
                </label>

                <div
                  className="change-date-time-inll position-relative"
                  
                >
                  <DatePicker
                    minDate={new Date().setHours(0, 0, 0, 0)}
                    highlightToday={false}
                    className="active labor-date-picker"
                    value={
                      costData?.startDate ? new Date(costData?.startDate) : null
                    }
                    plugins={[
                      <TimePicker
                        hideSeconds={true} // Optional: Hides seconds in time picker
                      />,
                    ]}
                    onChange={(value) => {
                      if (value && value.valueOf()) {
                        setCostData({
                          ...costData,
                          startDate: format(
                            value.valueOf(),
                            "yyyy-MM-dd  hh:mm a"
                          ), // Format for date and time with AM/PM
                        });
                      } else {
                        setCostData({
                          ...costData,
                          startDate: format(new Date(), "yyyy-MM-dd hh:mm a"),
                        });
                      }
                    }}
                    showMonthDropdown
                    showYearDropdown
                    placeholder={t.workOrders.form.add_due_date}
                    weekDays={[
                      t.workOrders.details_view.sun,
                      t.workOrders.details_view.mon,
                      t.workOrders.details_view.tue,
                      t.workOrders.details_view.wed,
                      t.workOrders.details_view.thu,
                      t.workOrders.details_view.fri,
                      t.workOrders.details_view.sat,
                    ]}
                    months={[
                      t.common.january,
                      t.common.february,
                      t.common.march,
                      t.common.april,
                      t.common.may,
                      t.common.june,
                      t.common.july,
                      t.common.august,
                      t.common.september,
                      t.common.october,
                      t.common.november,
                      t.common.december,
                    ]}
                    format="DD/MM/YYYY hh:mm a" // Date and Time format with AM/PM
                    enableTimePicker // Enable time selection
                    disableClock={false} // Optional: Include clock picker UI
                    disableCalendar={false} // Ensure calendar remains enabled
                  ></DatePicker>
                  <img
                    className="position-absolute"
                    src={calendar_icon}
                  />
                </div>
              </Form.Field>
            </GridColumn>

            <GridColumn className="pb-0">
              <Form.Field className="people-field">
                <label className="label-item">
                  {t.workOrders.filter.assignees}
                  <Asterisk color="#172B4D" />
                </label>
                <Dropdown
                  placeholder={t.workOrders.form.select_assignees}
                  fluid
                  selection
                  noResultsMessage={t.common.no_results_found}
                  search
                  error={
                    validation?.people?.error && validation?.people?.skipped
                  }
                  className="custom-dropdown-menu2"
                  options={options.people}
                  value={costData.people}
                  onChange={onValuesChange("people")}
                  onOpen={fetchPeopleOptions}
                  onBlur={(e) => {
                    if (validation.people.pattern(costData.people)) {
                      setValidation({
                        ...validation,
                        people: {
                          ...validation.people,
                          error: false,
                          skipped: true,
                        },
                      });
                    } else {
                      setValidation({
                        ...validation,
                        people: {
                          ...validation.people,
                          error: true,
                          skipped: true,
                        },
                      });
                    }
                  }}
                />

                {validation.people.error && validation.people.skipped ? (
                  <div className="label-error">{validation.people.message}</div>
                ) : (
                  ""
                )}
              </Form.Field>
            </GridColumn>
          </Grid>

          <Grid className="mb-0  mt-5" columns={2}>
            <GridColumn className="pt-0 pb-0">
              <Form.Field>
                <label className="label-item">
                  {t.workOrders.table.category}
                </label>
                <Dropdown
                  fluid
                  selection
                  noResultsMessage={t.common.no_results_found}
                  search
                  maxHeight={50}
                  className="custom-dropdown-menu2"
                  upward
                  options={options.category}
                  value={costData.category}
                  onChange={onValuesChange("category")}
                />
              </Form.Field>
            </GridColumn>

            <GridColumn className="pt-0">
              <Form.Field className="people-field">
                <label className="label-item">
                  {t.workOrders.cost.cost}
                  <Asterisk color="#172B4D" />
                </label>
                <Input
                  autoComplete="new-password"
                  type="number"
                  fluid
                  min={1}
                  placeholder={t.workOrders.cost.add_cost}
                  value={costData.cost}
                  onChange={(e) => {
                    let valueData = Number(e.target.value);
                    const isMaxQtyValid =
                      e.target.value != 0 &&
                      /^(\d{1,8})(\.\d{1,4})?$/.test(e.target.value);

                    if (isMaxQtyValid) {
                      let hrRate = Number(valueData.toFixed(2));
                      setCostData({
                        ...costData,
                        cost: String(hrRate),
                      });

                      setValidation({
                        ...validation,
                        cost: {
                          ...validation.cost,
                          error: false,
                          skipped: true,
                        },
                      });
                    } else if (!e.target.value) {
                      setCostData({
                        ...costData,
                        cost: "",
                      });

                      setValidation({
                        ...validation,
                        cost: {
                          ...validation.cost,
                          error: true,
                          skipped: true,
                        },
                      });
                    } else {
                      setCostData({
                        ...costData,
                        cost: "",
                      });

                      setValidation({
                        ...validation,
                        cost: {
                          ...validation.cost,
                          error: true,
                          skipped: true,
                        },
                      });
                    }
                  }}
                  onBlur={(e) => {
                    if (validation.cost.pattern(costData.cost)) {
                      setValidation({
                        ...validation,
                        cost: {
                          ...validation.cost,
                          error: false,
                          skipped: true,
                        },
                      });
                    } else {
                      setValidation({
                        ...validation,
                        cost: {
                          ...validation.cost,
                          error: true,
                          skipped: true,
                        },
                      });
                    }
                  }}
                  error={validation?.cost?.error && validation?.cost?.skipped}
                >
                  <input />

                  <span
                    className={`currency mr-2 p-1 d-flex align-items-center justify-content-center ${
                      selectedLanguage == "en" ? "ml-5" : "mr-5"
                    }`}
                  >
                    {organisationCurrency}
                  </span>
                </Input>
                {validation?.cost?.error && validation?.cost?.skipped ? (
                  <div className="label-error">{validation.cost.message}</div>
                ) : (
                  ""
                )}
              </Form.Field>
            </GridColumn>
          </Grid>

          <Grid className="mb-0 mt-5" columns={1}>
            <GridColumn className="pt-0">
              <Form.Field>
                <label className="label-item">
                  {t.workOrders.form.description}
                </label>
                <Input
                  autoComplete="new-password"
                  type="text"
                  fluid
                  placeholder={t.workOrders.form.description_text}
                  value={costData?.description}
                  onChange={onValuesChange("description")}
                ></Input>
              </Form.Field>
            </GridColumn>
          </Grid>
        </div>
      </Modal.Content>

      <div
        className={`modal-button-container ${
          selectedLanguage == "en" ? "mr-6" : "ml-10"
        }`}
      >
        <button
          onClick={() => {
            setaddLaborModal(false);
            setIsEdit(false);
            setValidation({
              people: {
                error: false,
                pattern: (code) => code != "",
                skipped: false,
                message: t.common.required_field,
              },
              cost: {
                error: false,
                pattern: (code) => code != "",
                skipped: false,
                message: t.common.required_field,
              },
            });
            setCostData({
              people: "",
              startDate: getLocalDateTime(organisationTimezone?.split("+")[1]),
              cost: "",
              description: "",
              category: "Other Cost",
            });
          }}
          className="modal-form-action-button"
        >
          {t.assets.form.cancel}
        </button>

        <button
          onClick={() => handleAssign()}
          className="modal-form-action-button light-blue"
        >
          {isEdit ? t.common.edit : t.common.add}
        </button>
      </div>
    </Modal>
  );
};

export default CostModal;
